import React from 'react';
import styles from './Top.module.css';
import model_icon from "../../static_files/Model.jpeg"
import {Link} from "react-router-dom";
function Top() {
  const solanaAddress = 'HmYccqizm8mwwabgqzJP8CEkaS15XRpVaSdAt2jcpump';

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(solanaAddress);
    alert('Copied');
  };

  return (
    <div className={styles.container}>

      {/* 上方：左侧文字 + 右侧图片 */}
      <div className={styles.topSection}>
        <div className={styles.leftArea}>
          <h1 className={styles.title}>The Only Official YZY Meme</h1>
          <p className={styles.paragraph} id="address">
            Join the YZY Community. This is History in the Making!
          </p>
        </div>
        <div className={styles.rightArea}>
          <img
            className={styles.image}
            src={model_icon}
            alt="YZY Meme"
          />
        </div>
      </div>

      {/* 中间：Solana Contract Address 显示 & 复制 */}
      <div className={styles.solanaAddressContainer}>
        <span  className={styles.solanaAddressLabel}>
          Solana Contract Address:
        </span>
        <code className={styles.solanaAddressCode}>
          {solanaAddress}
        </code>
        <button className={styles.copyButton} onClick={handleCopyAddress}>
          Copy Address
        </button>
      </div>

      {/* 底部 Footer：只显示 "YZY Memes" */}
      <footer className={styles.footer}>
        <p>YZY Memes are intended to function as an expression of support for, and engagement with, the ideals and beliefs embodied by the symbol "$YZY" and the associated artwork, and are not intended to be, or to be the subject of, an investment opportunity, investment contract, or security of any type. See <Link
        to="/terms"
        style={{ cursor: 'pointer', marginLeft: '5px' }}
      >
        See Terms & Conditions Here
      </Link>
 Here, See Card Allocation Here</p>
      </footer>
    </div>
  );
}

export default Top;